import React, { useMemo } from 'react';
import useBusinessLocations from '../../../../hooks/useBusinessLocations';
import { QuickInfoDropDown } from './QuickInfo';
import Name from './Name';
import Location from './Location';
import TradingHours from './TradingHours';
import Logo from './Logo';
import Reviews from './Reviews';
import Verified from './Verified';
import Services from './Services';
import Bottom from './Bottom';
import ProfileLink from './ProfileLink';

const Layout2 = ({
  data,
  cardLayout,
  url,
  market,
  categoryId,
  showQuickInfo,
  setShowQuickInfo,
  aggregateContacts,
  regionCitySearch,
}) => {
  const {
    name,
    slogan,
    suburb,
    state,
    region,
    listing_id: listingId,
    locations: businessLocations,
    servicing,
    distance,
    listviewservices,
    synopsis,
    abn,
    category,
    acn,
    s3_logo: logo,
    price_range: priceRange,
    display_reviews: displayReviews,
    opening_hours: openingHours,
    aggregate_reviews: reviewAggregates,
    reviews,
  } = data || {};
  const { locations } = useBusinessLocations(businessLocations);

  const price =
    priceRange && !['Not Relevant', 'N/A', 'Unspecified'].includes(priceRange)
      ? priceRange
      : null;
  const { callNumbers, emails, websites } = aggregateContacts || {};

  const { average_rating: averageRating, review_count: count } =
    reviewAggregates || {};

  const recentReview = useMemo(() => {
    if (reviews && !!reviews.length && displayReviews) {
      const {
        comment,
        author_name: displayName,
        posted_at: createdAt,
        rating,
        uuid: id,
      } = reviews[0];
      if (rating && Number(rating) >= 3)
        return {
          message: comment,
          displayName,
          createdAt,
          rating,
          id,
        };
      return null;
    }
    return null;
  }, [reviews, displayReviews]);

  return (
    <div className="Listview__Card__Layout Listview__Card__Layout--2">
      <TradingHours openingHours={openingHours} spacer />
      <ProfileLink url={url} className="Listview__Card__link">
        {name}
      </ProfileLink>
      <div className="Listview__Card__Layout__body">
        <div className="Listview__Card__Layout__left">
          <Verified abn={abn} acn={acn} />
          <Logo logo={logo} cardLayout={cardLayout} listingId={listingId} />
        </div>
        <div className="Listview__Card__Layout__right">
          <Name tag="h3">{name}</Name>
          <Services services={listviewservices} />
          <Location {...{ distance, locations, servicing, regionCitySearch }} />

          {price || (displayReviews && !!count) ? (
            <div className="Listview__Card__priceRating">
              {price ? (
                <span className="Listview__Card__priceRange">{price}</span>
              ) : null}
              {displayReviews && !!count ? (
                <div className="Listview__Card__reviewAggregate">
                  {count && price ? <i className="icon-weathermoon1" /> : null}
                  <Reviews averageRating={averageRating} count={count} />
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
      <Bottom
        {...{
          websites,
          emails,
          callNumbers,
          name,
          listingId,
          market,
          region,
          suburb,
          state,
          category,
          locations,
          slogan,
          categoryId,
          synopsis,
          showQuickInfo,
          setShowQuickInfo,
          recentReview,
        }}
      />
      <QuickInfoDropDown
        name={name}
        show={showQuickInfo}
        slogan={slogan}
        synopsis={synopsis}
        recentReview={recentReview}
        url={url}
      />
    </div>
  );
};

export default Layout2;
